import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/AboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/OurTeam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/TeamsHeroContent.tsx");
